"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialStateOfBooking = exports.bookingReducer = void 0;
var _reduxActions = require("redux-actions");
var _ramda = require("ramda");
var _actions = require("./actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @typedef {Object} BookingConfirmation
 * @property {string} id - The ID of the booking.
 * @property {string} viewLink - The link for viewing the booking.
 * @property {string} bookingsLink - The link for viewing bookings page.
 */
var initialStateOfBooking = exports.initialStateOfBooking = {
  bookingConfirmation: null
};
var bookingReducer = exports.bookingReducer = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.bookingActions.setBookingConfirmation, function (state, _ref) {
  var bookingConfirmation = _ref.payload;
  return (0, _ramda.assoc)('bookingConfirmation', bookingConfirmation, state);
}), initialStateOfBooking);